import {AuthorizationFetcher, utils} from '@wallaby-ui/core';

import {LIBRARY_NAME} from 'src/js/common/constants';

const logger = utils.LogUtils.getLogger('DocumentFetcher', LIBRARY_NAME);

/** @deprecated */
const DocumentFetcher = {
  get(requestUrl, docId) {
    if (!requestUrl || !docId) {
      logger.error(
        `Missing request endpoint, requestUrl: ${requestUrl}, docId: ${docId}`
      );
    }
    return AuthorizationFetcher.interceptedFetch(
      `${requestUrl}/${encodeURIComponent(docId)}`,
      {method: 'get'},
      {'Content-Type': 'application/json'}
    )
      .then(utils.FetcherUtils.processJsonResponse)
      .catch((response) => {
        utils.FetcherUtils.errorHandler(response);
      });
  },
};

export default DocumentFetcher;
